import { Navigate } from "react-router-dom";
import { userHasPermission } from "../../../helpers/user";

const PermissionRoute = ({ permission, children, redirectTo = "/" }) => {
  if (!userHasPermission(permission)) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
};

export default PermissionRoute;
